export default "__VITE_ASSET__Bq2aqm3o__"